import { usePrefs } from "@/context/PrefsContext";
import { companyChipClasses } from "@/lib/companyColors";

// Selector global de compañía (Parte D) — visible en el header de todas las pantallas de datos.
// Filtra Viajes, Resumen y Reportes; se recuerda por usuario vía preferencias del servidor.
export function CompanySwitch() {
  const prefs = usePrefs();
  if (!prefs) return null;
  const { companies, companyFilter, setCompanyFilter } = prefs;
  const options = [{ id: "all", nombre: "Todas", prefijo: "" }, ...companies];

  return (
    <div
      data-tour="global-company-switch"
      data-testid="global-company-switch"
      className="inline-flex items-center gap-0.5 rounded-full border border-border bg-slate-50 p-0.5"
    >
      {options.map((c) => {
        const active = companyFilter === c.id;
        return (
          <button
            key={c.id}
            type="button"
            onClick={() => setCompanyFilter(c.id)}
            data-testid={`company-switch-${c.id}`}
            className={`rounded-full px-3 py-1 text-xs font-semibold transition-colors ${
              active
                ? c.id === "all"
                  ? "bg-white text-foreground shadow"
                  : `${companyChipClasses(c.prefijo)} shadow`
                : "text-muted-foreground hover:text-foreground"
            }`}
          >
            {c.id === "all" ? "Todas" : c.nombre}
          </button>
        );
      })}
    </div>
  );
}
